import { useState, useEffect, useRef, useContext } from "react";
import Lottie from 'lottie-react';
import chatbotAnimation from '../assets/chatbotAnimation.json';
import '../css/chatbotai.css';
import axios from 'axios';
import { UserContext } from "../UserContext";

const ChatbotAi = () => {
  const [userDetails, setUserDetails] = useState({ name: '', email: '', mobile: '' });
  const [userDetailsCollected, setUserDetailsCollected] = useState();
  const [detailPromptStep, setDetailPromptStep] = useState(0);
  const [pendingMainOption, setPendingMainOption] = useState('');
  const pendingMainOptionRef = useRef(pendingMainOption);
  const [isChatboxOpen, setIsChatboxOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [Time, setTime] = useState();
  const [userInput, setUserInput] = useState('');
  const [stage, setStage] = useState(0);
  const [currentExpertRequestPolicyType, setCurrentExpertRequestPolicyType] = useState('');
  const [isExit, setIsExit] = useState(false);
  const chatboxWrapperRef = useRef(null);
  const messagesEndRef = useRef(null);
  const chatboxContentRef = useRef(null);
  const [otpAttempts, setOtpAttempts] = useState(0);
  const [askOtpResend, setAskOtpResend] = useState(false);
  const API_URL = process.env.REACT_APP_Dashboard_API_URL;
  const { UserId, user, UserToken, userRole, UserEmail, UserMobile } = useContext(UserContext);
  const [isLoggedIn, setIsLoggedIn] = useState(!!(user && UserToken && userRole));

  const otpInfoRef = useRef({ Otpverified: false, OtpverifiedId: 0 });

  const exitTimerRef = useRef(null);
  useEffect(() => {
    setIsLoggedIn(!!(user && UserToken && userRole));
    if (userDetailsCollected) {
      handleOptionClick(pendingMainOption);
    }
  }, [user, UserToken, userRole, userDetailsCollected]);

  useEffect(() => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 5);

    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    const fiveMinAhead = `${hours}:${minutes}`;
    setTime(fiveMinAhead.toString());
  }, []);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);
  useEffect(() => {
    pendingMainOptionRef.current = pendingMainOption;
  }, [pendingMainOption]);

  const AddInquriy = async (value) => {
    let type = '';
    if (
      pendingMainOptionRef.current === 'Term Insurance' ||
      pendingMainOptionRef.current === 'Health Insurance' ||
      pendingMainOptionRef.current === 'Car Insurance'
    ) {
      type = "Insurance Inquiries";
    } else if (pendingMainOptionRef.current === 'Claim Assistance') {
      type = "Claim Inquiry";
    } else if (pendingMainOptionRef.current === 'Compare Policies') {
      type = "Policy Review";
    } else if (pendingMainOptionRef.current === 'Talk to a Human Expert') {
      type = "General Inquiry";
    }

    const combined = pendingMainOptionRef.current === 'Talk to a Human Expert' ? pendingMainOptionRef.current : `${pendingMainOptionRef.current} : ${currentExpertRequestPolicyType}`;

    const inquiryData = new FormData();
    inquiryData.append("Name", value.name || "N/A");
    inquiryData.append("MobileNo", value.mobile || "N/A");
    inquiryData.append("Email", value.email || "N/A");
    inquiryData.append("Status", "New");
    inquiryData.append("InquiryType", type);
    inquiryData.append("UserId", UserId || otpInfoRef.current.OtpverifiedId);
    inquiryData.append("PreferredDate", new Date().toISOString().split('T')[0]);
    inquiryData.append("PreferredTime", Time);
    inquiryData.append("PolicyType", combined);
    inquiryData.append("IsLoggedIn", isLoggedIn);
    inquiryData.append("Otp", value.Otp || "");

    try {
      const response = await axios.post(`${API_URL}AddNewInquiries`, inquiryData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.status === 200) {
        removeTypingIndicator();
        addMessage(`Great! I'll connect you with an expert about ${pendingMainOptionRef.current}. Our expert will call you soon. 👍`, 'received');
        otpInfoRef.current = { Otpverified: true, OtpverifiedId: response.data.id };
        setIsLoggedIn(true);
        sendExitMessage();
        setStage(0);
      }
      else if (response.status === 202) {
        removeTypingIndicator();
        addMessage("OTP sent to your email. Please verify.", 'received');
        addMessage('Please enter your Otp . ', 'received');
        setDetailPromptStep(4);
      } else {
        console.warn(response.data?.errors || "Failed to send OTP.");
        setOtp("");
      }
    } catch (error) {
      setOtpAttempts(prev => prev + 1);

      if (otpAttempts + 1 >= 3) {
        addMessage("Too many wrong attempts. Please request a new OTP.", "received");
        setAskOtpResend(true);

        addMessage(
          <div className="chatbox-options">
            Do you want to resend OTP? <br />
            <button className="chatbox-option" onClick={() => handleOtpResendChoice("yes")}>Yes</button>
            <button className="chatbox-option" onClick={() => handleOtpResendChoice("no")}>No</button>
          </div>,
          "received"
        );
      } else {
        addMessage("Invalid OTP. Please try again.", "received");
        setDetailPromptStep(4);
      }
    }

  };

  const handleOtpResendChoice = async (choice) => {
    if (choice === "yes") {
      AddInquriy({
        name: userDetails.name || "N/A",
        mobile: userDetails.mobile || "N/A",
        email: userDetails.email || "N/A",
        policyType: currentExpertRequestPolicyType
      });
    } else if (choice === "no") {
      setAskOtpResend(false);
      setUserDetailsCollected(false);
      setDetailPromptStep(1);
      addMessage("Okay, let's start again. Please enter your full name:", "received");
    }
  };

  const openChatbox = () => {

    if (exitTimerRef.current) {
      clearTimeout(exitTimerRef.current);
      exitTimerRef.current = null;
    }
    setIsChatboxOpen(true);
    setMessages([]);
    setStage(0);
    setCurrentExpertRequestPolicyType('');
    setDetailPromptStep(0);
    setPendingMainOption('');
    setIsExit(false);
    if (isLoggedIn) {
      addMessage(
        <p>
          Hi {user} 👋 Welcome to <strong>Policy Samjho</strong> – Your Friendly Insurance Guide.
          <br />
          I'm here to help you understand insurance and choose the right policy.
        </p>,
        'received',
        'full-width-message'
      );
    } else {
      addMessage(
        <p>
          Hi there! 👋 Welcome to <strong>Policy Samjho</strong> – Your Friendly Insurance Guide.
          <br />
          I'm here to help you understand insurance and choose the right policy.
        </p>,
        'received',
        'full-width-message'
      );
    }
    setTimeout(() => {
      showMainOptions();
    }, 500);
  };

  const closeChatbox = () => {

    if (exitTimerRef.current) {
      clearTimeout(exitTimerRef.current);
      exitTimerRef.current = null;
    }

    setIsChatboxOpen(false);
    setMessages([]);
    setStage(0);
    setCurrentExpertRequestPolicyType('');
    setUserDetails({ name: '', email: '', mobile: '' });
    setUserDetailsCollected(false);
    setDetailPromptStep(0);
    setPendingMainOption('');
    otpInfoRef.current = { Otpverified: false, OtpverifiedId: 0 };
    setIsExit(false);
    setIsLoggedIn(false);
  };

  const addMessage = (text, type, className = '') => {
    setMessages((prevMessages) => [...prevMessages, { text, type, className }]);
  };

  const addTypingIndicator = () => {
    const dots = (
      <div className="typing-indicator">
        <span></span><span></span><span></span>
      </div>
    );
    addMessage(dots, 'received');
  };

  const removeTypingIndicator = () => {
    setMessages((prevMessages) =>
      prevMessages.filter(
        (msg) => msg.text?.type !== 'div' || msg.text?.props?.className !== 'typing-indicator'
      )
    );
  };

  const mainOptions = [
    'Term Insurance',
    'Health Insurance',
    'Car Insurance',
    'Claim Assistance',
    'Compare Policies',
    'Talk to a Human Expert'
  ];

  const handleOptionClick = (option) => {

    if (mainOptions.includes(option)) {
      if (pendingMainOption !== option) {
        setPendingMainOption(option);
      }

      if (!userDetailsCollected && detailPromptStep === 0) {
        if (isLoggedIn) {
          setUserDetailsCollected(true);
          setDetailPromptStep(0);

        } else {
          addMessage('Before proceeding, please enter your full name:', 'received');
          setDetailPromptStep(1);
        }
        return;
      }
    }

    addMessage(option, 'sent');
    addTypingIndicator();

    switch (option) {
      case 'Term Insurance':
        setTimeout(() => {
          removeTypingIndicator();
          addMessage(
            <>
              🧾 <strong>Term Insurance</strong> is a life insurance plan that gives financial security to your family if you die during the policy term.
              <br />
              <b>Key Benefits:</b>
              <ul>
                <li>Lowest premium, highest coverage</li>
                <li>Pure protection (no maturity benefit)</li>
                <li>Ideal for earning members with dependents</li>
              </ul>
              Would you like to:
            </>,
            'received'
          );
          addMessage(
            <div className="chatbox-options">
              <button className="chatbox-option" onClick={() => handleOptionClick('Calculate premium')}>🧮 Calculate premium</button>
              <button className="chatbox-option" onClick={() => handleOptionClick('View best plans')}>📑 View best plans</button>
              <button className="chatbox-option" onClick={() => handleOptionClick('Talk to an advisor (Term)')}>🧑‍💼 Talk to an advisor</button>
            </div>,
            'received',
            'full-width-message'
          );
          setStage(0);
        }, 2000);
        break;

      case 'Health Insurance':
        setTimeout(() => {
          removeTypingIndicator();
          addMessage(
            <>
              🏥 <strong>Health Insurance</strong> covers your hospital and medical expenses. It’s essential for emergencies and planned treatments.
              <br />
              <b>Covers:</b>
              <ul>
                <li>Hospitalization & surgery</li>
                <li>Ambulance & medicines</li>
                <li>Pre & post-hospitalization</li>
              </ul>
              Would you like to:
            </>,
            'received'
          );
          addMessage(
            <div className="chatbox-options">
              <button className="chatbox-option" onClick={() => handleOptionClick('Find best family health plan')}>🩺 Find best family health plan</button>
              <button className="chatbox-option" onClick={() => handleOptionClick('Get premium estimate')}>🧮 Get premium estimate</button>
              <button className="chatbox-option" onClick={() => handleOptionClick('Talk to health policy expert')}>🧑‍💼 Talk to health policy expert</button>
            </div>,
            'received',
            'full-width-message'
          );
          setStage(0);
        }, 2000);
        break;

      case 'Car Insurance':
        setTimeout(() => {
          removeTypingIndicator();
          addMessage(
            <>
              🚗 <strong>Car Insurance</strong> protects your car or bike from accidents, theft, and damage.
              <br />
              <b>Includes:</b>
              <ul>
                <li>Third-party cover (mandatory)</li>
                <li>Own-damage cover</li>
                <li>Add-ons (zero depreciation, engine cover, etc.)</li>
              </ul>
              Would you like to:
            </>,
            'received'
          );
          addMessage(
            <div className="chatbox-options">
              <button className="chatbox-option" onClick={() => handleOptionClick('Renew policy')}>🔁 Renew policy</button>
              {/* <button className="chatbox-option" onClick={() => handleOptionClick('Check vehicle policy offers')}>📄 Check vehicle policy offers</button> */}
              <button className="chatbox-option" onClick={() => handleOptionClick('Talk to advisor (Car)')}>🧑‍🔧 Talk to advisor</button>
            </div>,
            'received',
            'full-width-message'
          );
          setStage(0);
        }, 2000);
        break;

      case 'Claim Assistance':
        setTimeout(() => {
          removeTypingIndicator();
          addMessage(
            <>
              📝 Need help filing a claim? Don’t worry. I’ll guide you step by step.
              <br />
              🛠️ <strong>Steps to file a claim:</strong>
              <ul>
                <li>Inform the insurer immediately</li>
                <li>Submit required documents</li>
                <li>Wait for verification & approval</li>
                <li>Claim gets settled</li>
              </ul>
              Which type of claim do you need help with?
            </>,
            'received'
          );
          addMessage(
            <div className="chatbox-options">
              <button className="chatbox-option" onClick={() => handleOptionClick('Life Insurance Claim')}>💀 Life Insurance</button>
              <button className="chatbox-option" onClick={() => handleOptionClick('Health Insurance Claim')}>🏥 Health Insurance</button>
              <button className="chatbox-option" onClick={() => handleOptionClick('Vehicle Insurance Claim')}>🚗 Vehicle Insurance</button>
            </div>,
            'received',
            'full-width-message'
          );
          addMessage(
            <p className="chatbox-instruction">(If needed, we can connect you with our claim expert)</p>,
            'received',
            'full-width-message'
          );
          setStage(5);
        }, 2000);
        break;

      case 'Compare Policies':
        setTimeout(() => {
          removeTypingIndicator();
          addMessage(
            <>
              🔍 Want to compare insurance plans? We’ve got you covered.
              <br />
              Select a category:
            </>,
            'received'
          );
          addMessage(
            <div className="chatbox-options">
              <button className="chatbox-option" onClick={() => handleOptionClick('Term Plans Comparison')}>🧾 Term Plans</button>
              <button className="chatbox-option" onClick={() => handleOptionClick('Health Policies Comparison')}>🏥 Health Policies</button>
              <button className="chatbox-option" onClick={() => handleOptionClick('Vehicle Insurance Comparison')}>🚗 Vehicle Insurance</button>
            </div>,
            'received',
            'full-width-message'
          );
          addMessage(
            <>
              I’ll show you top-rated options based on:
              <ul>
                <li>Your age & income</li>
                <li>Sum assured</li>
                <li>Premium affordability</li>
                <li>Claim Settlement Ratio</li>
              </ul>
              Would you like to start a quick comparison?
            </>,
            'received'
          );
          addMessage(
            <div className="chatbox-options">
              <button className="chatbox-option" onClick={() => handleOptionClick('Yes, let’s start')}>✅ Yes, let’s start</button>
              <button className="chatbox-option" onClick={() => handleOptionClick('No, go back')}>❌ No, go back</button>
            </div>,
            'received',
            'full-width-message'
          );
          setStage(6);
        }, 2000);
        break;

      case 'Talk to a Human Expert':
      // handleExpertConnect(option);
      // break;

      case 'Calculate premium':
      case 'View best plans':
      case 'Find best family health plan':
      case 'Get premium estimate':
      case 'Renew policy':
      case 'Check vehicle policy offers':
      case 'Life Insurance Claim':
      case 'Health Insurance Claim':
      case 'Vehicle Insurance Claim':
      case 'Term Plans Comparison':
      case 'Health Policies Comparison':
      case 'Vehicle Insurance Comparison':
      case 'Yes, let’s start':
      case 'Talk to an advisor (Term)':
      case 'Talk to health policy expert':
      case 'Talk to advisor (Car)':
        handleExpertConnect(option);
        break;

      case 'No, go back':
        setTimeout(() => {
          removeTypingIndicator();
          showMainOptions();
        }, 2000);
        break;

      default:
        setTimeout(() => {
          removeTypingIndicator();
          addMessage('I\'m not sure how to respond to that. Please select an option or try rephrasing your question.', 'received');
          showMainOptions();
        }, 2000);
        break;
    }
  };

  const handleExpertConnect = (policyTypeForInquiry) => {
    setCurrentExpertRequestPolicyType(policyTypeForInquiry);
    setTimeout(() => {
      AddInquriy({
        name: userDetails.name || user || "N/A",
        mobile: userDetails.mobile || UserMobile || "N/A",
        email: userDetails.email || UserEmail || "N/A",
        policyType: policyTypeForInquiry
      });
    }, 2000);
  };

  const handleUserInput = (input) => {
    setUserInput('');

    if (exitTimerRef.current) {
      clearTimeout(exitTimerRef.current);
      exitTimerRef.current = null;
    }
    setIsExit(false);


    if (isExit) {
      setIsExit(false);
      setMessages([]);
      showMainOptions();
      setStage(0);
      setDetailPromptStep(0);
      return;
    }

    if (detailPromptStep === 1) {
      setUserDetails({ ...userDetails, name: input });
      addMessage(input, 'sent');
      addMessage('Thanks! Please enter your email address:', 'received');
      setDetailPromptStep(2);
      return;
    }

    if (detailPromptStep === 2) {
      if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(input)) {
        addMessage(input, 'sent');
        addMessage('Invalid email address. Please enter a valid email:', 'received');
        return;
      }
      setUserDetails({ ...userDetails, email: input });
      addMessage(input, 'sent');
      addMessage('Great! Now, please enter your 10-digit mobile number:', 'received');
      setDetailPromptStep(3);
      return;
    }

    if (detailPromptStep === 3) {
      if (!/^\d{10}$/.test(input)) {
        addMessage(input, 'sent');
        addMessage('Invalid mobile number. Please enter a 10-digit mobile:', 'received');
        return;
      }
      setUserDetails({ ...userDetails, mobile: input });
      addMessage(input, 'sent');
      setUserDetailsCollected(true);
      setDetailPromptStep(0);
      addMessage('Thanks! Your details have been saved.', 'received');

      return;
    }

    if (detailPromptStep === 4) {
      addMessage(input, 'sent');
      setUserDetailsCollected(true);
      setDetailPromptStep(0);
      // handleVerifyOtp(input);
      AddInquriy({
        name: userDetails.name || "N/A",
        mobile: userDetails.mobile || "N/A",
        email: userDetails.email || "N/A",
        Otp: input || ""
      });
      return;
    }


    addMessage(input, 'sent');
    addTypingIndicator();

    if (stage === 3) {
      removeTypingIndicator();
      if (!/^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/(\d{2}|\d{4})$/.test(input)) {
        addMessage(input, 'sent');
        addMessage('Invalid date format. Please enter in dd/mm/yyyy or d/m/yy format.', 'received');
        return;
      }
      setStage(4);
      addMessage('Please enter your preferred appointment time (HH:MM AM/PM):', 'received');
    } else if (stage === 4) {
      removeTypingIndicator();
      if (!/^(0?[1-9]|1[0-2]):[0-5][0-9] ?(AM|PM)$/i.test(input)) {
        addMessage(input, 'sent');
        addMessage('Invalid time format. Please enter in HH:MM AM/PM format.', 'received');
        return;
      }
      addMessage('Your appointment has been scheduled. Our expert will contact you shortly.', 'received');
      sendExitMessage();
      setStage(0);
    } else if (stage === 5) {
      setTimeout(() => {
        removeTypingIndicator();
        addMessage(`Okay, you need help with a ${input} claim. We'll connect you with an expert.`, 'received');
        sendExitMessage();
        setStage(0);
      }, 2000);
    } else if (stage === 6) {
      setTimeout(() => {
        removeTypingIndicator();
        addMessage(`Alright, you want to compare ${input}. We can help you with that.`, 'received');
        sendExitMessage();
        setStage(0);
      }, 2000);
    } else {
      setTimeout(() => {
        removeTypingIndicator();
        showMainOptions();
      }, 2000);
    }
  };

  const showMainOptions = () => {
    addMessage(
      <p>What do you need help with today?</p>,
      'received'
    );
    addMessage(
      <div className="chatbox-options">
        <button className="chatbox-option" onClick={() => handleOptionClick('Term Insurance')}>✅ Term Insurance</button>
        <button className="chatbox-option" onClick={() => handleOptionClick('Health Insurance')}>✅ Health Insurance</button>
        <button className="chatbox-option" onClick={() => handleOptionClick('Car Insurance')}>✅ Car Insurance</button>
        <button className="chatbox-option" onClick={() => handleOptionClick('Claim Assistance')}>✅ Claim Assistance</button>
        <button className="chatbox-option" onClick={() => handleOptionClick('Compare Policies')}>✅ Compare Policies</button>
        <button className="chatbox-option" onClick={() => handleOptionClick('Talk to a Human Expert')}>✅ Talk to a Human Expert</button>
      </div>,
      'received',
      'full-width-message'
    );
    addMessage(
      <p className="chatbox-instruction">
        👉 Click a topic above or type your question below.
      </p>,
      'received',
      'full-width-message'
    );
    setStage(0);

  };

  const sendExitMessage = () => {
    setTimeout(() => {
      setIsExit(true);
      addMessage(
        <>
          Thanks for visiting <strong>Policy Samjho</strong> 💡
          <br />
          Feel free to come back anytime.
          <br />
          Your insurance journey made simple! 😊
          <br />
          <p className="chatbox-instruction">
            👉 Visit FAQs | 💬 Chat again | ☎️ Contact Us: <strong>18005703990</strong>
          </p>
          <p className="chatbox-instruction">
            If you want to continue chatting, type <strong>any keyword</strong> to restart.
          </p>
        </>,
        'received',
        'full-width-message'
      );
    }, 2500);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && userInput.trim() !== '') {
      handleUserInput(userInput);
    }
  };

  return (
    <div className="chatbox-container">
      {!isChatboxOpen && (
        <div className="chatbox-float-btn" onClick={openChatbox}>
          <Lottie animationData={chatbotAnimation} loop autoplay className="chatbox-float-animation" />
        </div>
      )}
      <div ref={chatboxWrapperRef} className={`chatbox-message-wrapper ${isChatboxOpen ? 'open' : ''}`}>
        <div className="chatbox-header">
          <span className="chatbox-title">PolicyDost</span>
          <button className="chatbox-close-button" onClick={closeChatbox}>X</button>
        </div>
        <div className="chatbox-message-content" ref={chatboxContentRef}>
          {messages.map((message, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: message.type === 'sent' ? 'flex-end' : 'flex-start',
                width: '100%',
                marginBottom: '12px',
              }}
            >
              <div
                className={`chatbox-message-item ${message.type} ${message.className}`}
                style={{
                  backgroundColor: message.type === 'sent' ? '#F5A526' : '#2A3A54',
                  color: 'white',
                  borderRadius: '6px',
                  padding: '14px 15px',
                  letterSpacing: '1px',
                  margin: '4px 0',
                  display: 'inline-block',
                  wordWrap: 'break-word',
                  textAlign: message.type === 'sent' ? 'right' : 'left',
                  maxWidth: message.className === 'full-width-message' ? '100%' : '80%',
                }}
              >
                {typeof message.text === 'string' ? (
                  <span dangerouslySetInnerHTML={{ __html: message.text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }} />
                ) : (
                  message.text
                )}
              </div>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>
        <div className="chatbox-input-wrapper">
          <input
            type="text"
            className="chatbox-message-input"
            placeholder="Type your response..."
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            onKeyPress={handleKeyPress}
            disabled={detailPromptStep !== 0 ? false : undefined}
          />
          <button
            className="chatbox-send-button"
            onClick={() => handleUserInput(userInput)}
            disabled={!userInput.trim()}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatbotAi;